import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'

import i18n from '@/libs/i18n'
import axios from '@axios'
import { endpoint } from '@/@core/endpoint'
import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'

// 3rd party plugins
import '@/libs/acl'
import '@/libs/portal-vue'
import '@/libs/clipboard'
import '@/libs/toastification'
import '@/libs/sweet-alerts'
import '@/libs/vue-select'
import '@/libs/tour'

// Axios Mock Adapter
import '@/@fake-db/db'

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Composition API
Vue.use(VueCompositionAPI)

// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
require('@core/assets/fonts/feather/iconfont.css') // For form-wizard

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

Vue.config.errorHandler = (err, vm, info) => {
  try {
    axios.post(`${endpoint()}/global/err/`, { msg: err.stack.toString(), page: document.location.href })
      .then(() => {
        console.error('Ошибка! Разработчики уже работают, над её устранением.', err, vm, info)
        // eslint-disable-next-line no-alert
        alert('Ошибка! Разработчики уже работают, над её устранением.')
      })
      .catch(() => {
        console.error('Ошибка! Разработчики уже работают, над её устранением.', err, vm, info)
        // eslint-disable-next-line no-alert
        alert('Ошибка! Разработчики уже работают, над её устранением.')
      })
  // eslint-disable-next-line no-empty
  } catch { }
}
new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
